import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyled,
  LightBulbIconStyled,
} from './styles';

export default () => {
  return (
    <SectionContainer
      id='fafa-page-first-advisor-meeting'
      className='js-show-on-submit'
      backgroundVariant='lightC'
      themeType='lightTheme'>
      <Row align='center'>
        <Col
          align='center'
          medium={8}>
          <ColStyled>
            <LightBulbIconStyled />
          </ColStyled>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            Let&#39;s get ready for your first <WidowBlock>advisor meeting.</WidowBlock>
          </Typography>
          <Typography
            align='center'
            nextElement='link'>
            We&#39;ve put together some helpful tips on what to have handy and what you
            can expect to talk about at the first meeting with your advisor.
          </Typography>
          <Link
            id='fafa-page-first-advisor-meeting-tips-button'
            variant='primary'
            themeType='lightTheme'
            ariaLabel='See our tips about your first financial advisor meeting'
            linkUrl='/email-landing/prospect/get-the-most-from-your-first-advisor-meeting?utm_source=NMCOM&amp;utm_medium=LandingPage&amp;utm_term=na&amp;utm_campaign=FAFA&amp;utm_content=Let%27s_Get_Ready'>
            See our tips
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
